import "./NursingCaregiverInTelAvivWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInSainteCatherine from "./sections/PatioDoorRepairServicesInSainteCatherine";
import RelatedServices from "./sections/RelatedServices";
import ServiceGrid from "./sections/ServiceGrid";
import FaqAccordion from "./sections/FaqAccordion";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function NursingCaregiverInTelAvivWithinFiveHoursPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInSainteCatherine />
      <RelatedServices />
      <ServiceGrid />
      <FaqAccordion />
      <FinalCta />
      <Footer />
    </div>;
}